module.exports = __webpack_public_path__ + "static/img/smartControl1.cb944fa3.png";